import { persist } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';
import { fetchCart } from '../components/fetch-cart';
const CART_STORE_VERSION = 1;
const CartStore = createStore()(persist((set, get) => ({
    cartHeading: '',
    lateDeliveryLocalization: '',
    checkoutButtonText: '',
    checkoutButtonURL: '',
    cartItems: [],
    crossSells: [],
    promoSliderData: [],
    summary: null,
    freeShippingInfo: null,
    freeShippingLocalization: null,
    promocodeLocalization: null,
    cartTotalsLocalization: null,
    hideFreeDeliveryOffer: false,
    isLoading: false,
    error: null,
    hasFetchedCart: false,
    cartEmptyMessage: '',
    goToShopLink: '',
    goToShopButtonText: '',
    crossSellLocalization: null,
    cart_item_count: 0,
    promocode: '',
    promocodeStatus: '',
    promocodeStatusMessage: '',
    currency: 'PLN',
    language: 'en',
    skipNextCartTrack: false,
    shouldFetchCart: false,
    setFetchCart: (value) => set({ shouldFetchCart: value }),
    setSkipNextCartTrack: (value) => set({ skipNextCartTrack: value }),
    fetchCart: () => fetchCart(set, get),
}), { name: 'cart_data', version: CART_STORE_VERSION }));
export { CartStore };
